import {
  CUSTOM_COMPONENT_UPDATE_CUSTOM_FUNCTION_BEGIN,
  CUSTOM_COMPONENT_UPDATE_CUSTOM_FUNCTION_SUCCESS,
  CUSTOM_COMPONENT_UPDATE_CUSTOM_FUNCTION_FAILURE,
  CUSTOM_COMPONENT_UPDATE_CUSTOM_FUNCTION_DISMISS_ERROR,
} from './constants';

import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function updateCustomFunction(args = {}) {
  return (dispatch) => {
    dispatch({
      type: CUSTOM_COMPONENT_UPDATE_CUSTOM_FUNCTION_BEGIN,
    });

    const header = builderSurfaceJsonContentHeader(args.projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.put(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${args.version}/custom-function/${args.customFunctionId}`,
        args.updatedData,
        header,
      );

      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: CUSTOM_COMPONENT_UPDATE_CUSTOM_FUNCTION_SUCCESS,
              data: res.data,
            });
            toast.success('Function Updated Successfully');
            resolve(res);
          } else {
            dispatch({
              type: CUSTOM_COMPONENT_UPDATE_CUSTOM_FUNCTION_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: CUSTOM_COMPONENT_UPDATE_CUSTOM_FUNCTION_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUpdateCustomFunctionError() {
  return {
    type: CUSTOM_COMPONENT_UPDATE_CUSTOM_FUNCTION_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CUSTOM_COMPONENT_UPDATE_CUSTOM_FUNCTION_BEGIN:
      return {
        ...state,
        updateCustomFunctionPending: true,
        updateCustomFunctionError: null,
      };

    case CUSTOM_COMPONENT_UPDATE_CUSTOM_FUNCTION_SUCCESS:
      const updatedFunctions = state.customFunctions.map((func) =>
        func.uuid === action.data.uuid ? action.data : func,
      );
      return {
        ...state,
        updateCustomFunctionPending: false,
        updateCustomFunctionError: null,
        customFunctions: updatedFunctions,
      };

    case CUSTOM_COMPONENT_UPDATE_CUSTOM_FUNCTION_FAILURE:
      return {
        ...state,
        updateCustomFunctionPending: false,
        updateCustomFunctionError: action.data.error,
      };

    case CUSTOM_COMPONENT_UPDATE_CUSTOM_FUNCTION_DISMISS_ERROR:
      return {
        ...state,
        updateCustomFunctionError: null,
      };

    default:
      return state;
  }
}
